export class ILLSignature {
 eSigCheck: string;
 eSigReason: string;
 eSigUser: string;
 eSigDateTime: Date;
}